import * as actions from './actionTypes';

const getStoreObject = data => {
  const {
    title,
    full_name,
    email,
    country_code,
    mobile,
    status,
    gstn,
    agency_name,
    business_type,
    address,
    pan_number,
    city,
    state,
    pincode,
    pan_verified,
    tnc_url,
    kyc_type,
    account_type,
    document_type,
    pan_success,
    pan_name,
    user_msg,
    pan_type,
    account_exists,
    verify_mmt_password,
    message,
    additional_document_type,
    btnDisabled,
    mpnfo,
    nof,
    country,
    auth_token,
    ed_license_number,
    region,
  } = data;
  return {
    title: title || '',
    fullName: full_name || '',
    countryCode: country_code || '+91',
    email: email || '',
    mobile: mobile || '',
    tncLink: tnc_url || '',
    status: status || '',
    agencyName: agency_name || '',
    panNumber: pan_number || '',
    panUploaded: pan_verified || false,
    gstNumber: gstn || '',
    businessType: business_type || '',
    businessTypeList: account_type || null,
    docTypeList: document_type || null,
    address: address || '',
    state: state || '',
    city: city || '',
    pincode: pincode || '',
    kycUploaded: kyc_type && kyc_type !== '' ? true : false,
    kycDocType: kyc_type || '',
    panSuccess: pan_success || false,
    pan_name: pan_name || false,
    user_msg: user_msg || '',
    pan_type: pan_type || false,
    verify_mmt_password,
    account_exists,
    message,
    additionalDoc: additional_document_type || null,
    mpnfo: mpnfo || false,
    nof: nof || false,
    region: region || '',
    country: region === 'AE' ? true : false,
    auth_token: auth_token,
    ed_license_number: ed_license_number || '',
  };
};

export const updateInitialData = (token, directLanding, data?) => {
  if (!data) {
    return {
      type: actions.UPDATE_INITIAL_DATA,
      token,
      directLanding,
    };
  } else {
    const dataObj = getStoreObject(data);
    return {
      type: actions.UPDATE_INITIAL_DATA,
      token,
      directLanding,
      ...dataObj,
    };
  }
};

export const updatePreviousPageName = prevPageName => {
  return {
    type: actions.UPDATE_PREV_PAGE_NAME,
    prevPageName,
  };
};

// new flow actions
// Send OTP  screen-1
export const sendMobileOtp = (userData, data) => {
  const mobile = userData.mobile;
  const countryCode = userData.country_code;
  return {
    type: actions.SEND_OTP_SUCCESS,
    mobile,
    countryCode,
    token: data.token,
    status: data.status || '',
    error: '',
    loginLoad: false,
    otpheading: data.heading,
    otpSubheading: data.sub_heading,
    exisitngUser: data.eu,
    nextScreen: data.screen,
    mpnfo: data.mpnfo || false,
    nof: data.nof,
  };
};

export const loadingForLogin = flag => {
  return {
    type: actions.LOADER_LOGIN_HOME,
    loginLoad: flag,
  };
};

export const changeCountryCode = flag => {
  return {
    type: actions.CHANGE_USER_COUNTRY,
    country: flag,
    user_country: flag,
  };
};

export const sendMobileOtpError = (userData, error) => {
  const countryCode = userData.country_code;
  const mobile = userData.mobile;
  return {
    type: actions.REGISTER_USER_DATA_ERROR,
    countryCode,
    mobile,
    error,
    loginLoad: false,
  };
};

export const disabledContinueBtn = flag => {
  return {
    type: actions.DISABLED_BUTTON,
    btnDisabled: flag,
  };
};

// SCREEN 2 verify otp
export const verifyMobileOtpSuccess = data => {
  return {
    type: actions.VERIFY_MOBILE_OTP_SUCCESS,
    error: '',
    businessTypeList: data.account_type || null,
    docTypeList: data.document_type || null,
    status: data.status || '',
    panUploaded: false,
    gstLoad: false,
    kycUploaded: false,
    kycDocType: '',
    requestIp: data.request_ip,
    accountId: data.account_id,
    sessionExpire: data.verification_validity,
    additionalDoc: data.additional_document_type || null,
    nextScreen: data.screen,
    email: data?.b2c_details?.email || '',
    fullName: data?.full_name || '',
    account_exists: data?.account_exists,
    verify_mmt_password: data?.account_exists,
  };
};

export const verifyMobileOtpError = error => {
  return {
    type: actions.VERIFY_MOBILE_OTP_ERROR,
    error,
  };
};

// SCREEN 3 user details
export const submitDetailsSuccess = (response, data) => {
  return {
    type: actions.SUBMIT_SUCCESS,
    error: null,
    gstNumber: data.gstn,
    businessType: data.business_type,
    address: data.address,
    state: data.state,
    city: data.city,
    pincode: data.pincode,
    title: data.title,
    fullName: data.full_name,
    email: data.email,
    nextScreen: response.screen,
  };
};

export const submitDetailsError = (data, error) => {
  return {
    type: actions.SUBMIT_FAIL,
    gstNumber: data.gstn,
    businessType: data.business_type,
    address: data.address,
    state: data.state,
    city: data.city,
    pincode: data.pincode,
    title: data.title,
    fullName: data.fullName,
    email: data.email,
    error,
  };
};

export const nextScreenSuccess = data => {
  return {
    type: actions.KYCDOC_SUCCESS,
    error: null,
    nextScreen: data.screen,
  };
};

// SCREEN 1
export const registerNewUserSuccess = (userData, data) => {
  const title = userData.title;
  const fullName = userData.full_name;
  const countryCode = userData.country_code;
  const mobile = userData.mobile;
  const email = userData.email;
  return {
    type: actions.REGISTER_USER_DATA_SUCCESS,
    title,
    fullName,
    countryCode,
    mobile,
    email,
    token: data.token,
    tncLink: data.tnc_url || '',
    status: data.status || '',
    error: '',
    nextLoad: false,
  };
};

export const loadingForNext = flag => {
  return {
    type: actions.LOADING_FOR_NEXT,
    nextLoad: flag,
  };
};

export const registerNewUserError = (userData, error) => {
  const title = userData.title;
  const fullName = userData.full_name;
  const countryCode = userData.country_code;
  const mobile = userData.mobile;
  const email = userData.email;
  return {
    type: actions.REGISTER_USER_DATA_ERROR,
    title,
    fullName,
    countryCode,
    mobile,
    email,
    error,
    nextLoad: false,
  };
};

// SCREEN 2
export const verifyOTPSuccess = data => {
  return {
    type: actions.VERIFY_OTP_SUCCESS,
    error: '',
    businessTypeList: data.account_type || null,
    docTypeList: data.document_type || null,
    status: data.status || '',
    panUploaded: false,
    gstLoad: false,
    kycUploaded: false,
    kycDocType: '',
    requestIp: data.request_ip,
    accountId: data.account_id,
    sessionExpire: data.verification_validity,
    additionalDoc: data.additional_document_type || null,
  };
};

export const verifyOTPError = error => {
  return {
    type: actions.VERIFY_OTP_ERROR,
    error,
  };
};

export const resendCount = (data, userOption) => {
  if (userOption === 'motp') {
    return {
      type: actions.RESEND_COUNT,
      mobile_count: data.sms_count ? true : false,
    };
  } else {
    return {
      type: actions.RESEND_COUNT,
      email_count: data.email_count ? true : false,
    };
  }
};

// SCREEN 3
export const loadingForKycInfo = () => {
  return {
    type: actions.LOADING_FOR_KYCINFO,
    gstLoad: true,
    error: null,
    panSuccess: false,
    pan_type: false,
  };
};

export const resetPANInfo = () => {
  return {
    type: actions.RESET_PAN_INFO,
    panInfo: null,
    panUploaded: false,
    gstLoad: false,
    panSuccess: false,
    pan_type: false,
  };
};

export const submitKYCModalInfo = update => {
  return {
    type: actions.UPDATE_MODAL_KYC,
    updatedKYCModal: update,
  };
};

export const updatePanInfoSuccess = (panInfo, panNumber, agencyName) => {
  return {
    type: actions.UPADTE_PAN_INFO_SUCCESS,
    panNumber,
    agencyName,
    panInfo,
    error: null,
    panUploaded: true,
    gstLoad: false,
  };
};

export const updatePanInfoError = error => {
  return {
    type: actions.UPADTE_PAN_INFO_ERROR,
    error,
    panUploaded: false,
    gstLoad: false,
  };
};

export const updateNameIssue = (data, panNumber, agencyName) => {
  return {
    type: actions.UPDATE_NAME_ISSUE,
    panSuccess: data.pan_name ? true : false,
    pan_name: data.pan_name || false,
    user_msg: data.message,
    pan_type: data.individual || false,
    panNumber,
    agencyName,
  };
};

export const uploadKYCSuccess = type => {
  return {
    type: actions.UPLOAD_KYC_SUCCESS,
    error: null,
    kycUploaded: true,
    kycDocType: type,
  };
};

export const uploadKYCError = (error, type) => {
  return {
    type: actions.UPLOAD_KYC_ERROR,
    error,
    kycUploaded: false,
    kycDocType: type,
  };
};

export const uploadFacadeSuccess = () => {
  return {
    type: actions.UPLOAD_FACADE_SUCCESS,
    error: null,
    facadeUploaded: true,
  };
};

export const uploadFacadeError = error => {
  return {
    type: actions.UPLOAD_FACADE_ERROR,
    error,
    facadeUploaded: false,
  };
};

export const submitDataSuccess = (response, data) => {
  return {
    type: actions.SUBMIT_SUCCESS,
    error: null,
    gstNumber: data.gstn,
    businessType: data.business_type,
    address: data.address,
    state: data.state,
    city: data.city,
    pincode: data.pincode,
  };
};

export const submitDataError = (data, error) => {
  return {
    type: actions.SUBMIT_FAIL,
    gstNumber: data.gstn,
    businessType: data.business_type,
    address: data.address,
    state: data.state,
    city: data.city,
    pincode: data.pincode,
    error,
  };
};

// SCREEN 4
export const setUserCredentials = data => {
  return {
    type: actions.SET_USER_CREDENTIALS,
    registered: true,
    auth_token: data.auth_token,
    status: data.status || '',
    error: null,
  };
};

export const setUserCredentialsError = error => {
  return {
    type: actions.SET_USER_CREDENTIALS_ERROR,
    error,
  };
};

export const uploadPassportInfoError = error => {
  return {
    type: actions.UPADTE_PASSPORT_INFO_ERROR,
    error,
  };
};

// Login to signup redirect
export const resetInitialData = () => {
  return {
    type: actions.RESET_INITIAL_DATA,
    title: '',
    fullName: '',
    countryCode: '+91',
    email: '',
    mobile: '',
    status: '',
    token: '',
  };
};

export const updateLob = lob => {
  return {
    type: actions.UPDATE_LOB,
    payload: lob,
  };
};
